<script lang="ts">
  import { getNewsletterStores } from "../../newsletterStores";

  const GOOGLE_MAPS_API_KEY = "AIzaSyCxTYoLc2kAwV3DqRh_FYi-s1g8WEtbzYg";

  export let address: string = "";
  export let size: string = "380x164";
  const { ctx } = getNewsletterStores();

  function getMapUrl(address: string) {
    if (address && address.trim().length > 0) {
      const url = encodeURIComponent(
        `https://maps.googleapis.com/maps/api/staticmap?center=${encodeURI(
          address
        )}&key=${GOOGLE_MAPS_API_KEY}&size=${size}&maptype=roadmap&markers=color:red%7C${encodeURI(address)}`
      );
      return `${ctx.href("/app/pages/sign_google_map_url", { type: "event", ignoreStorage: true })}?input_url=${url}`;
    }
    return "";
  }

  $: backgroundMap = `background-image: url(${getMapUrl(address)});`;
</script>

<div style={backgroundMap} class="absolute inset-0 flex items-center justify-center bg-center bg-no-repeat bg-cover">
  {#if !address || !address.trim()}
    <div class="flex flex-col items-center">
      <i class="mb-1.5 text-gray-600 material-icons notranslate">map</i>
      <p class="text-gray-600 text-12">No map preview</p>
    </div>
  {/if}
</div>
